import React from "react";
import {Link} from "react-router-dom";
import Avatar from "../Avatar";
const ReceiverCard = ({user}) => {
  return (
    <div className="flex min-w-[180px] flex-col bg-white border border-gray-200 rounded-xl shadow-sm hover:shadow-md transition-all duration-200 hover:scale-[1.02] p-5 gap-4 h-full w-full sm:w-auto items-start">
      <div className="flex items-center justify-between w-full">
        <div className="relative">
          <Avatar 
            src={null} // ReceiverCard doesn't seem to have image data, so using null
            className="w-12 h-12"
            bgColor="bg-gradient-to-br from-green-100 to-emerald-100" 
            iconColor="text-green-500"
          />
          <div className="absolute -bottom-1 -right-1 w-4 h-4 bg-green-500 border-2 border-white rounded-full"></div>
        </div>
      </div>

      <div className="flex flex-col gap-2 w-full">
        <Link to={`/receiver/${user?.id}`} className="text-gray-900 font-semibold text-base hover:text-blue-600 transition-colors">
          {user?.firstname} {user?.lastname}
        </Link>
        <p className="text-gray-500 truncate w-full font-normal text-sm">
          {user?.email}
        </p>
      </div>

      <Link
        to={`/receiver/${user?.id}`}
        className="w-full mt-auto bg-blue-50 hover:bg-blue-100 text-blue-600 font-medium py-2.5 px-4 rounded-lg text-center transition-colors duration-200 text-sm"
      >
        View Profile
      </Link>
    </div>
  );
};

export default ReceiverCard;
